/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { StripePriceTier } from "./StripePriceTier";
export const StripePrice = core.serialization.object({
    id: core.serialization.string(),
    unitAmount: core.serialization.number().optional(),
    tiers: core.serialization.list(StripePriceTier).optional(),
});
